import { render, staticRenderFns } from "./PreviewUploadedVideo.vue?vue&type=template&id=1fb65b88&"
import script from "./PreviewUploadedVideo.vue?vue&type=script&lang=js&"
export * from "./PreviewUploadedVideo.vue?vue&type=script&lang=js&"
import style0 from "./PreviewUploadedVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports